// utils/TimeHelper.js

class TimeHelper {
  /**
   * Converts minutes to HH:MM format
   * @param {number|null} minutes - Number of minutes
   * @returns {string} HH:MM format or empty string if null/undefined
   * @example
   * TimeHelper.minutesToTimeString(90) // "01:30"
   * TimeHelper.minutesToTimeString(0) // "00:00"
   * TimeHelper.minutesToTimeString(null) // ""
   */
  static minutesToTimeString(minutes) {
    if (minutes === null || minutes === undefined) minutes = 0;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  /**
   * Converts HH:MM format to minutes
   * @param {string} timeString - HH:MM format
   * @returns {number|null} Number of minutes or null if empty/invalid
   * @example
   * TimeHelper.timeStringToMinutes("01:30") // 90
   * TimeHelper.timeStringToMinutes("00:00") // 0
   * TimeHelper.timeStringToMinutes("") // null
   */
  static timeStringToMinutes(timeString) {
    if (!timeString || timeString.trim() === '') return null;
    const [hours, minutes] = timeString.split(':').map(Number);

    // Basic validation
    if (isNaN(hours) || isNaN(minutes)) return null;

    return hours * 60 + minutes;
  }

  /**
   * Formats minutes to readable format (e.g., "1h 30min")
   * @param {number|null} minutes - Number of minutes
   * @returns {string} Readable format
   * @example
   * TimeHelper.formatMinutesReadable(90) // "1h 30min"
   * TimeHelper.formatMinutesReadable(60) // "1h"
   * TimeHelper.formatMinutesReadable(45) // "45min"
   */
  static formatMinutesReadable(minutes) {
    if (minutes === null || minutes === undefined) return '';

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours === 0) return `${mins}min`;
    if (mins === 0) return `${hours}h`;
    return `${hours}h ${mins}min`;
  }
}

export default TimeHelper;
